// removed by extract-text-webpack-plugin
module.exports = {"imageHolder":"_2PtQxzRgjb","imageNotLoaded":"_2kUvLzav4P","imageError":"_1NJ6_upmo0","invalidFile":"_2tBWA4Z5zt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageSlatePlugin/ImageSlatePlugin.scss
// module id = 367
// module chunks = 0